/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-03 08:51:30
 * @LastEditTime: 2020-09-27 09:38:06
 * @Description: 客户store
 */
import {
    getCustomerList,
    updateCustomer,
    updateManyCustomer,
    deleteCustomer,
    createCustomer,
    getCustomerSimpleList,
    getUserCustomerRolesCount,
    getCustomerById,
    getCustomerQZList,
    getCustomerQzById,
    getAllCustomerList,
    reloadCustomerStatus
} from '@/api/customer'
import Vue from 'vue'

const state = {
    customers: [],
    customerQZList: [],
    currentCustomerQz: null,
    customersSimple: [],
    customer: {},
    bulkCustomers: [],
    detailCustomers: [],
    userCustomerRolesCount: [],
    detailCustomersId: '',
    selectCustomer: {},
    totalCounts: 0,
}

const getters = {
    // getCustomerById: (state) => (id) => {
    //     return state.customers.find(x => x._id === id)
    // },
    getDetailCustomerById: (state) => (id) => {
        return state.detailCustomers.find(x => x._id === id)
    },
}

const actions = {
    async getCustomersAction({
        commit
    }, payload) {
        try {
            const res = await getCustomerList(payload)
            commit('SETCUSTOMERLIST', res.data);
            return res.data.customerList
        } catch (error) {
            throw error
        }
    },

    async getCustomerSimpleListAction({
        commit
    }, payload) {
        try {
            const res = await getCustomerSimpleList(payload)
            commit('SET_CUSTOMER_SIMPLE_LIST', res.data);
            return res.data
        } catch (error) {
            throw error
        }
    },

    async getAllCustomerListAction({
        commit
    }, payload) {
        try {
            const res = await getAllCustomerList(payload)
            commit('SET_ALL_CUSTOMER_LIST', res.data);
            return res.data
        } catch (error) {
            throw error
        }
    },

    async getCustomerByIdAction({
        commit
    }, id) {
        try {
            const customer = await getCustomerById(id)
            commit('SET_SELECT_CUSTOMER', customer.data);
            return customer.data
        } catch (error) {
            throw error.message
        }
    },
    async getCanApplyCustomersAction({
        commit
    }, payload) {
        try {
            const res = await getCustomerSimpleList(payload)
            commit('SETCANAPPLYCUSTOMERLIST', res.data);
            return res.data.customerList
        } catch (error) {
            throw error
        }
    },
    // 批量权限的获取客户列表
    async getbulkcustomersAction({
        commit
    }, payload) {
        try {
            const res = await getCustomerList(payload)
            commit('SETBULKCUSTOMERLIST', res.data);
            return res.data.customerList
        } catch (error) {
            throw error
        }
    },
    // 客户详情页的获取客户列表
    async getDetailCustomersAction({
        commit
    }, payload) {
        try {
            const res = await getCustomerSimpleList(payload)
            commit('SETDETAILCUSTOMERLIST', res.data);
            return res.data.customerList
        } catch (error) {
            throw error
        }
    },
    // 获取客户权限统计
    async getUserCustomerRolesCountAction({
        commit
    }, payload) {
        try {
            const res = await getUserCustomerRolesCount(payload)
            commit('SET_USER_CUSTOMER_ROLES_COUNT', res.data);
            return res.data
        } catch (error) {
            throw error
        }
    },
    // 保存客户详情页的客户ID
    setDetailCustomersIdAction({
        commit
    }, id) {
        commit('SETDETAILCUSTOMERSID', id)
    },
    // 保存详细页点击的客户信息
    saveSelectCustomerAction({
        commit
    }, payload) {
        commit('SET_SELECT_CUSTOMER', payload)
    },

    async createCustomerAction({
        commit
    }, payload) {
        try {
            const newCustomer = await createCustomer(payload);
            commit('ADDNEWCUSTOMER', newCustomer.data)
        } catch (error) {
            throw error
        }
    },
    async updateCustomerAction({
        commit
    }, payload) {
        try {
            const newCustomer = await updateCustomer(payload.id, payload.data);
            commit('UPDATECUSTOMER', newCustomer.data)
            return newCustomer.data
        } catch (error) {
            throw error
        }
    },
    async updateManyCustomerAction({
        commit
    }, payload) {
        try {
            const newCustomer = await updateManyCustomer(payload)
            commit('UPDATEMANYCUSTOMER', newCustomer.data)
            return newCustomer.data
        } catch (error) {
            throw error
        }
    },
    async deleteCustomerAction({
        commit
    }, payload) {
        try {
            await deleteCustomer(payload.id)
            commit('DELETECUSTOMER', payload.id)
            return payload.id
        } catch (error) {
            throw error
        }
    },
    // 客户权责表
    async getCustomerQZListAction({
        commit
    }, payload) {
        try {
            const res = await getCustomerQZList(payload)
            commit('SET_CUSTOMER_QZ_LIST', res.data);
            return res.data.customerList
        } catch (error) {
            throw error
        }
    },
    async getCustomerQZByIdAction({
        commit
    }, payload) {
        try {
            const res = await getCustomerQzById(payload)
            commit('SET_CURRENT_CUSTOMER_QZ', res.data);
            return res.data
        } catch (error) {
            throw error
        }
    },
    // 重置客户的状态
    async reloadCustomerStatusAction({
        commit
    }, payload) {
        try {
            const res = await reloadCustomerStatus(payload)
            return res;
        } catch (error) {
            throw error
        }
    },
}

const mutations = {
    SETCUSTOMERLIST(state, payload) {
        state.customers = payload.customerList
        state.totalCounts = payload.totalCounts
    },
    SET_CUSTOMER_SIMPLE_LIST(state, payload) {
        state.customersSimple = payload.customerList
    },
    SET_ALL_CUSTOMER_LIST(state, payload) {
        state.customersSimple = payload.customerList
    },
    SET_USER_CUSTOMER_ROLES_COUNT(state, payload) {
        state.userCustomerRolesCount = payload
    },
    SETCANAPPLYCUSTOMERLIST(state, payload) {
        state.customers = payload.customerList.filter(x => {
            return !x.hasOwnProperty('customerDevelop')
        })
        state.totalCounts = payload.totalCounts
    },
    // 修改 批量权限客户列表的state
    SETBULKCUSTOMERLIST(state, payload) {
        state.bulkCustomers = payload.customerList
    },
    // 修改 客户详情页列表的state
    SETDETAILCUSTOMERLIST(state, payload) {
        state.detailCustomers = payload.customerList
        state.totalCounts = payload.totalCounts
    },
    // 修改客户详情页的客户ID
    SETDETAILCUSTOMERSID(state, id) {
        state.detailCustomersId = id
    },
    // 客户详情页信息
    SET_SELECT_CUSTOMER(state, payload) {
        state.selectCustomer = payload
    },
    ADDNEWCUSTOMER(state, customer) {
        state.customers.unshift(customer)
        state.totalCounts++
    },
    UPDATECUSTOMER(state, customer) {
        Vue.set(state.customers, state.customers.findIndex(x => x._id === customer._id), customer);
        state.selectCustomer = customer
    },
    UPDATEMANYCUSTOMER(state, payload) {},
    DELETECUSTOMER(state, id) {
        state.customers = state.customers.filter(e => e._id !== id)
        state.totalCounts--
    },
    SET_CUSTOMER_QZ_LIST(state, payload) {
        state.customerQZList = payload.customerList
        state.totalCounts = payload.totalCounts
    },
    SET_CURRENT_CUSTOMER_QZ(state, payload) {
        state.currentCustomerQz = payload
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}